var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLanguageIcon = function SvgLanguageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M19 10a9 9 0 1 0-9 9h.09A8.92 8.92 0 0 0 19 10.09zm-1.5 0a7.5 7.5 0 0 1-.27 1.973.37.37 0 0 1-.195.24.38.38 0 0 1-.285.037 2.6 2.6 0 0 1-1.14-.953L13.945 8.8a1.88 1.88 0 0 0-1.56-.833h-.322a2.063 2.063 0 0 1 0-4.124h2.077a.36.36 0 0 1 .217.067A7.5 7.5 0 0 1 17.5 10M2.635 8.62a.37.37 0 0 1 .368-.307H6.25a2.58 2.58 0 0 1 1.852.75l.848.862a2.625 2.625 0 0 1 .105 3.6l-1.02 1.147a1.87 1.87 0 0 0-.473 1.245v.623a.37.37 0 0 1-.172.315.39.39 0 0 1-.353 0A7.5 7.5 0 0 1 2.5 10a7 7 0 0 1 .135-1.38"
  })));
};
export { SvgLanguageIcon as ReactComponent };